import comp from "./DeadlinesV2AddEditDetails";
export default comp;
